import React from 'react';
import cn from 'classnames';
import { PropsWithTestId } from '../../../../../../../types';
import { FileDownloadModuleType } from '../index';
import { DownloadIcon } from '../DownloadIcon';
import { Heading, Line, Paragraph } from '../../../components';
import { Button } from '../../../../Button';
import ImageTag from '../../../../../../shared/ImageTag/ImageTag';
import styles from './ThumbStylePortrait.module.scss';
import gtmService from '../../../../../../../utils/gtm';
import { CTAClickType } from '../../../../../../../utils/gtm/types';

export type ThumbStylesPortraitProps = Pick<
  FileDownloadModuleType,
  'ctatext' | 'title' | 'titleSize' | 'text' | 'file' | 'image'
>;

export default function ThumbStylesPortrait(
  props: PropsWithTestId<ThumbStylesPortraitProps>,
) {
  const { ctatext, title, titleSize, text, file, image, testId } = props;

  const onClickHandler = () => {
    gtmService.ga4VideoPlay({
      cta_title: title,
      filename: file,
      description: ctatext,
    } as unknown as CTAClickType);
  };

  return (
    <div data-testid={testId} className={cn('row middle-md', styles.wrapper)}>
      <div className="col-xs-12 col-sm-12 col-lg-8">
        <div className={styles.contentWrapper}>
          {title && (
            <>
              <div className={styles.titleWrapper}>
                <DownloadIcon className={styles.downloadIcon} />
                <Heading className={styles.heading} titleSize={titleSize}>
                  {title}
                </Heading>
              </div>
              <Line className={styles.line} />
            </>
          )}
          <Button
            to={`/uploads/${file.filename}`}
            onClick={onClickHandler}
            data-testid="hub-module-download-link"
          >
            {ctatext || 'Download'}
          </Button>
          {text && <Paragraph text={text} className={styles.paragraph} />}
        </div>
      </div>
      <div className="col-xs-12 col-sm-12 col-lg-4">
        <ImageTag className={styles.holder} src={image?.path} alt="" />
      </div>
    </div>
  );
}

ThumbStylesPortrait.defaultProps = {
  testId: 'hub-module-thumb-style-portrait',
};
